export class GlobalConstants {
  public static genericError = 'Something went wrong, please try again later - FRONT';

  public static unauthorized  = 'You are not authorized to access this page';

  public static nameRegex = '[a-zA-Z0-9 ]*';

  public static emailRegex = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}';

  public static contactNumberRegex = '^[e0-9]{10,10}$';

  public static error = 'error';

  public static productExistError = 'Product Already Exist';

  public static productAdded = 'Product Added Sucessfully;';
}
